import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import { Navigate, useParams } from "react-router-dom";
import Paginator from "../../components/Paginator";
import Wrapper from "../../components/Wrapper"; 
import { BiSolidFilePdf } from "react-icons/bi";

const ClientInvoice = ()=>{
   
    const[invoiceItems, setInvoiceItems] = useState([]);
    const [page, setPage] = useState(1);
    const[fileName,setFileName] = useState("");
    const [lastPage, setLastPage] = useState(1);
    let {id} = useParams();

    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`clientInvoice?page=${page}`);
            setInvoiceItems(data.data);
            console.log(data);
            setLastPage(data.meta.last_page)

        }
        )();
    },[page]);

    const doDownload = async () => {
        const now = new Date();
        const epochTime = now.getTime(); 
        const epochTimeInSeconds = Math.floor(epochTime / 1000);
        setFileName("invoice_" + epochTimeInSeconds);
        try {
            const { data } = await axios.post('download/invoice', {
                name:fileName, 
                client:parseInt(id)
            }, { responseType: 'blob' });
            const blob = new Blob([data], { type: 'text/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            console.log(data);
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    }

   
    return (
        <Wrapper pageTitle={'Invoices'}>
            
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                <div className="w-full overflow-x-auto bg-white text-right leading-10 text-gray-700 pr-2"> <BiSolidFilePdf className="text-red-600 self-end m-2.5" onClick={doDownload}/></div>
                    <div>Invoice to: </div>
                    <div className="w-full overflow-x-auto">
                    {invoiceItems ? (
        invoiceItems.length > 0 ? (
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Description </th> 
                                    <th className="px-4 py-3">Quantity </th>
                                    <th className="px-4 py-3">Amount</th> 
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >

                                    {invoiceItems.map((invoiceItems)=>{
                                         return(
                                             <tr key={invoiceItems.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{invoiceItems.id}</td>
                                                  
                                                 <td className="px-4 py-3 text-sm">{invoiceItems.product.name}</td>
                                                 <td className="px-4 py-3 text-sm">{invoiceItems.quantity}</td>
                                                 <td className="px-4 py-3 text-sm">{invoiceItems.total}</td>
                                                  </tr>
                                         );
                                     })
                                 }
                            </tbody>
                        </table>
                          ) : (
                            <p>No data available</p>
                          )
                        ) : (
                          <p>Loading...</p>
                        )}
                    </div>
 
                </div>
             </Wrapper>
         );
};
export default ClientInvoice;